import { useAppRouter } from '@/common/route/useAppRouter';
import { useCrudActions } from '@/common/view/useCrudActions';
import { ROUTE_NAME_ROLE } from '@/modules/role/router';
import { roleService } from '@/services/role';
import useVuelidate from '@vuelidate/core';
import { required } from '@vuelidate/validators';
import { reactive } from 'vue';

const roleOption = [
    { value: 'ROLE_TESTER', label: 'Tester' },
    { value: 'ROLE_MODERATOR', label: 'Moderator' },
    { value: 'ROLE_MANAGER', label: 'Manager' },
    { value: 'ROLE_ADMIN', label: 'Admin' }
];

export default function () {
    const router = useAppRouter();
    const crudAction = useCrudActions();

    const model = reactive({
        email: null,
        role: null
    });

    const validations = {
        email: { required },
        role: { required }
    };

    const v$ = useVuelidate(validations, model);

    const addAppRole = crudAction.excuteAndNotify({
        validator: v$,
        request: () => {
            const isAccountId = /^\d+$/.test(model.email);
            const accountId = isAccountId ? model.email : null;
            const email = isAccountId ? null : model.email;

            return roleService.app.add(accountId, email, model.role);
        },
        onSuccess: () => router.push({ name: ROUTE_NAME_ROLE.APP.INDEX })
    });

    return { v$, model, roleOption, validations, fetch, addAppRole };
}
